import axios from "axios";

import { BASE_URL, ROLES } from "../components/helpers/constants";
import {
  decryptPayload,
  getAccountArchivedMessage,
  getObjLength,
  handleExpiredSessionRedirect,
  isAccountArchivedApiResponse,
  shouldExpireSessionForApiStatus,
} from "../components/helpers/utils";

export const getAPIPayload = async (data) => {
  console.log("payload", data);
  if (getObjLength(data)) {
    let passingData = data.data === undefined ? {} : data.data;
    let finalURL = data.url;
    let preURL = data.url.split("?")?.[0];
    let postURL = data.url.split("?")?.[1];
    let device = decryptPayload(localStorage.getItem("isMobile"));

    // to identify logged in devices
    if (
      decryptPayload(localStorage.getItem("roles"))?.includes(ROLES.customer) ||
      decryptPayload(localStorage.getItem("roles"))?.includes(
        ROLES.professional
      ) ||
      decryptPayload(localStorage.getItem("path"))?.includes("create-account")
    ) {
      if (device) {
        finalURL = `${preURL}?device_type=${device}${
          postURL ? "&" + postURL : ""
        }`;
      } else {
        finalURL = `${preURL}?device_type=web${postURL ? "&" + postURL : ""}`;
      }
    }

    return await getAPICall(
      finalURL,
      passingData,
      data.token,
      data?.brokertoken,
      data?.responseType,
    );
  } else {
    return "";
  }
};

export const getAPICall = async (url, reqbody, token, brokertoken, responseType) => {
  const params =
    reqbody && typeof reqbody === "object" && Object.keys(reqbody).length > 0
      ? reqbody
      : undefined;

  return await axios
    .get(`${BASE_URL}${url}`, {
      params,
      timeout: 120000,
      headers: {
        authorization: token
          ? `Bearer ${localStorage.getItem("authToken")}`
          : brokertoken
          ? `Bearer ${localStorage.getItem("agentauthToken")}`
          : null,
      },
      ...(responseType ? { responseType } : {}),
    })
    .then(function (response) {
      console.log("in GetPayload gettRequest...", response.data);
      if (responseType === "text") {
        return {
          success: true,
          html: response.data,
          statuscode: response.status,
        };
      }
      return response.data;
    })
    .catch(function (error) {
      console.error("Error in GetAPIPayload gettRequest", error);
      const isTimeout =
        error.code === "ECONNABORTED" ||
        error.message?.toLowerCase?.().includes("timeout");
      let responseData = error.response?.data;
      if (typeof responseData === "string") {
        try {
          responseData = JSON.parse(responseData);
        } catch (_parseError) {
          // Keep the original string body when it is not JSON.
        }
      }
      let data = {
        success: false,
        error: error.message,
        message:
          (typeof responseData === "object" && responseData?.message) ||
          (typeof responseData === "string" && responseData) ||
          error.message,
        data: responseData || {
          success: false,
          message: isTimeout
            ? "UCC document extraction is still processing. Please try again in a moment."
            : error.message,
        },
        statuscode: error.response?.status,
      };
      const status = error.response?.status;
      if (shouldExpireSessionForApiStatus(status, responseData)) {
        handleExpiredSessionRedirect(window.location.pathname, {
          accountArchived: isAccountArchivedApiResponse(responseData),
          message: isAccountArchivedApiResponse(responseData)
            ? getAccountArchivedMessage(responseData)
            : undefined,
          responseData,
        });
      }
      return data;
    });
};
